import React from "react";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useStyles } from "./style";

const DatePicker = ({ handleDateChange, value = null }) => {
  const classes = useStyles();
  const today = new Date();
  today.setDate(today.getDate() - 1);
  const maxDate = new Date();
  maxDate.setDate(today.getDate() + 6);

  const getRoundedDate = () => {
    const now = new Date();
    const minutes = now.getMinutes();

    if (minutes < 30) {
      now.setMinutes(0);
    } else {
      now.setMinutes(30);
    }

    now.setSeconds(0);
    now.setMilliseconds(0);
    return now;
  };

  const roundedDate = getRoundedDate();
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDateTimePicker
        inputVariant="outlined"
        variant="dialog"
        format="dd/MM/yyyy hh:mm a"
        ampm={true}
        minDate={today}
        maxDate={maxDate}
        id="date-picker-dialog"
        placeholder={"Select date and time"}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        value={value || roundedDate}
        minutesStep={30}
        InputProps={{
          readOnly: true, // Prevents manual typing
          onFocus: (e) => e.target.blur(), // Prevents the input from gaining focus
        }}
        onChange={handleDateChange}
        className={classes.datePicker}
      />
    </MuiPickersUtilsProvider>
  );
};

export default DatePicker;
